// extracted by mini-css-extract-plugin
module.exports = {"notFound":"_32sDw","image":"_2A_jZ"};